import React from "react";

const IpIcon = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_1189_9611)">
        <path
          d="M18.5128 16.1794C18.3478 16.0144 18.2653 15.9319 18.2344 15.8368C18.2072 15.7531 18.2072 15.6629 18.2344 15.5793C18.2653 15.4841 18.3478 15.4016 18.5128 15.2366L19.6955 14.0539C19.3817 13.912 19.0333 13.833 18.6664 13.833C17.2857 13.833 16.1664 14.9523 16.1664 16.333C16.1664 16.5376 16.191 16.7365 16.2374 16.9268C16.287 17.1306 16.3119 17.2325 16.3074 17.2969C16.3028 17.3643 16.2928 17.4002 16.2617 17.4601C16.232 17.5174 16.1751 17.5743 16.0614 17.6881L13.4581 20.2913C13.1129 20.6365 13.1129 21.1962 13.4581 21.5413C13.8033 21.8865 14.3629 21.8865 14.7081 21.5413L17.3114 18.9381C17.4251 18.8243 17.482 18.7674 17.5393 18.7377C17.5993 18.7067 17.6351 18.6966 17.7025 18.692C17.7669 18.6876 17.8688 18.7124 18.0726 18.7621C18.263 18.8084 18.4618 18.833 18.6664 18.833C20.0471 18.833 21.1664 17.7137 21.1664 16.333C21.1664 15.9662 21.0874 15.6178 20.9455 15.3039L19.7628 16.4866C19.5978 16.6516 19.5153 16.7341 19.4202 16.765C19.3365 16.7922 19.2464 16.7922 19.1627 16.765C19.0675 16.7341 18.985 16.6516 18.82 16.4866L18.5128 16.1794Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1189_9611">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(12 13)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IpIcon;
